import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_ERROR_PROMPT_SCHEDULE_PAGE } from "../../store/actionTypes/scheduleActionType";

const ScheduleErrorPrompt = () => {
  const dispatch = useDispatch();
  const {
    isErrorPromptSchedulePage: isError,
    errorMessageSchedulePage: errorMessage,
  } = useSelector((state) => state.schedule);

  const { t: tCommon } = useTranslation();

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_SCHEDULE_PAGE, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("errorPromptTitle")}</AlertTitle>
        {errorMessage}
      </Alert>
    )
  );
};

export default ScheduleErrorPrompt;
